// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","por-logo":"Header_por-logo__SDwQ+"};